<svg
  viewBox="0 0 1024 1024"
  style={direction === 'up' ? 'transform: scaleY(-1)' : ''}
>
  <path
    d="M476.455 806.696L95.291 425.532Q80.67 410.911 80.67 390.239t14.621-34.789 35.293-14.117 34.789 14.117L508.219 698.8l349.4-349.4q14.621-14.117 35.293-14.117t34.789 14.117 14.117 34.789-14.117 34.789L546.537 800.142q-19.159 19.159-38.318 19.159t-31.764-12.605z"
  />
</svg>

<style lang="less">
  svg {
    fill: currentColor;
    width: 12px;
    height: 12px;
    margin: auto 0 auto 6px;
  }
</style>

<script>
  export let direction = 'down';
</script>
